/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'lock-solid': {
    width: 16,
    height: 16,
    viewBox: '0 0 25 25',
    data: '<path pid="0" d="M20.5 10H19V5.5a5.5 5.5 0 0 0-11 0V10H6.5A1.5 1.5 0 0 0 5 11.5v12A1.5 1.5 0 0 0 6.5 25h14a1.5 1.5 0 0 0 1.5-1.5v-12a1.5 1.5 0 0 0-1.5-1.5zm-4.526 10.342A.5.5 0 0 1 15.5 21h-4a.5.5 0 0 1-.474-.658l.846-1.959a2.488 2.488 0 0 1-.76-2.641 2.459 2.459 0 0 1 1.7-1.65 2.495 2.495 0 0 1 2.315 4.292zM18 10H9V5.5a4.5 4.5 0 0 1 9 0z"/>'
  }
})
